import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "Add/update the specified cart item.";
export const method = "POST";
export const operationId = "quoteGuestCartItemRepositoryV1SavePost";
export const path = "/V1/guest-carts/{cartId}/items";
export interface PathParams {
    cartId: string;
}
export interface Body {
    cartItem: Definitions.QuoteDataCartItemInterface;
}
export type Response = Response200 | Response400 | ResponseDefault;
export type Response200 = Definitions.QuoteDataCartItemInterface;
export type RespKeys = (keyof Definitions.QuoteDataCartItemInterface)[];
export type Response400 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "postJSON">;
export function execute<T extends RespKeys | undefined>(pathParams: PathParams, body: Body, effects: MinimalEffects, fields?: T): T extends RespKeys ? Observable<Pick<Definitions.QuoteDataCartItemInterface, T[number]>> : Observable<Response200> {
    return effects.postJSON(effects.apiUrl(operationId)(path, pathParams, fields), body, effects.restHeaders({})) as any;
}
